module.exports = __webpack_public_path__ + "static/media/mithras_tn.2b3b27f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Latium/mithras_tn.jpg
// module id = 680
// module chunks = 0